import OfficeMobileNavBarBottom from '@components/Offices/OfficeProfile/OfficeMobileNavBarBottom'
import { useEnquiryFormContext } from '@context/EnquiryFormContext'
import Button from '@global/Button'
import Image from '@global/Image'
import Raiting from '@global/Raiting'
import ShareButton from '@global/ShareButton'
import { Link } from '@routes'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import * as S from './StickyNavOffice.styled'

const EnquiryForm = dynamic(() => import('@global/Form/EnquiryForm'), {
  ssr: false,
})

const StickyNavOffice = ({
  directionUrl,
  name,
  address,
  image,
  shareObject,
  phone,
  officeId,
  officeSlug,
  reaRating,
  reaNumberOfReviews,
}) => {
  const { setShowEnquiryForm } = useEnquiryFormContext()
  const [top, setTop] = useState(0)
  const [isFixedNav, setIsFixedNav] = useState(false)
  const [prevScrollY, setPrevScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const isScrollingUp = currentScrollY < prevScrollY

      const announcement = document.getElementById('announcement')

      if (announcement) {
        setTop(announcement.clientHeight)
      } else {
        setTop(0)
      }

      if (isScrollingUp) {
        setIsFixedNav(false)
      } else if (currentScrollY > 400) {
        if (!isFixedNav) {
          setIsFixedNav(true)
        }
      } else {
        if (isFixedNav) {
          setIsFixedNav(false)
        }
      }

      setPrevScrollY(currentScrollY)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isFixedNav, prevScrollY])

  return (
    <>
      <S.StickyNavOffice active={isFixedNav} top={top}>
        <S.Office>
          <Image src={image} alt={name} />
          <S.OfficeInfo>
            <S.OfficeInfoName>{name}</S.OfficeInfoName>
            <S.OfficeInfoAddress>{address}</S.OfficeInfoAddress>
            <Raiting rating={reaRating} numberOfReviews={reaNumberOfReviews} />
          </S.OfficeInfo>
        </S.Office>

        <S.StickyNavOfficeActions>
          <div>
            {directionUrl && address && (
              <Link route={directionUrl} target='_blank' passHref>
                <Button border color='secondary'>
                  Directions
                </Button>
              </Link>
            )}
            <Button
              border
              color='secondary'
              onClick={() => {
                setShowEnquiryForm(true)
              }}
            >
              Send Enquiry
            </Button>
            {phone && (
              <a href={`tel:${phone}`} target='_blank'>
                <Button border color='secondary'>
                  Call Now
                </Button>
              </a>
            )}
          </div>
          <ShareButton
            heading='Share this Office'
            shareInfo={shareObject}
            modalPosition='right'
          />
        </S.StickyNavOfficeActions>
      </S.StickyNavOffice>

      <OfficeMobileNavBarBottom phone={phone} officeSlug={officeSlug} />

      <EnquiryForm
        type='office'
        officePageTitle={`Barry Plant ${name}`}
        headerInfo={{
          image,
          title: `Barry Plant ${name}`,
          description: address,
          id: officeId,
        }}
      />
    </>
  )
}

export default StickyNavOffice
